import Blue from "../core";

new Blue({
	name: 'Form Validate',
	selector: ".stat",
	setup(stat) {
		let statNumerator = stat.getAttribute("data-stat-fraction").split("/")[0].trim();
		statNumerator = parseFloat(statNumerator);
		let statDenominator = stat.getAttribute("data-stat-fraction").split("/")[1].trim();
		statDenominator = parseFloat(statDenominator);

		const fillCircle = stat.querySelector(".stat__circle-fill");

		const makePie = () => {
			const decimal = statNumerator / statDenominator;
			const offset = (1 - decimal);
			fillCircle.style.setProperty("--offset", offset);
		};

		makePie();
	}
});